// Generated types for ActionRoot
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ActionDefinitionReadAPI, ActionDefinitionWriteAPI } from '../../sysml/types/actiondefinition';
import { ActionDefinitionReadAPISchemaObject, ActionDefinitionWriteAPISchemaObject } from '../../sysml/types/actiondefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionRootReadAPI extends ActionDefinitionReadAPI {
}

export interface ActionRootWriteAPI extends ActionDefinitionWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionRootReadAPISchema: z.ZodType<ActionRootReadAPI> = ActionDefinitionReadAPISchemaObject.extend({}).passthrough();

export const ActionRootWriteAPISchema: z.ZodType<ActionRootWriteAPI> = ActionDefinitionWriteAPISchemaObject.extend({}).passthrough();
